import { Skeleton } from '@mui/material';
import { grey } from '@mui/material/colors';
import { Box } from 'shared/mui/Box';

export const CommissionsTabsTaskSkeleton = () => {
  return (
    <Box
      sx={{
        mt: 1,
        p: 2,
        borderRadius: 2,
        position: 'relative',
        backgroundColor: grey[50],
        border: '1px solid #e0e0e0',
      }}
    >
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}
      >
        <Box>
          <Skeleton height={20} sx={{ mb: 0.5 }} variant="text" width={240} />
          <Skeleton height={16} variant="text" width={160} />
        </Box>
        <Skeleton height={24} variant="circular" width={24} />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Skeleton height={12} variant="circular" width={12} />
          <Skeleton height={20} variant="text" width={90} />
        </Box>
        <Skeleton height={20} variant="text" width={130} />
      </Box>
      <Skeleton height={8} sx={{ borderRadius: 4 }} variant="rounded" width="100%" />
    </Box>
  );
};
